export const getCurrencySymbol = currencySettings => {
  if (!currencySettings) {
    return '';
  }
  const charCodeRegex = /&#(\d+);/g;
  return (currencySettings.symbol ?? '&#8364;').replace(charCodeRegex, (_match, code) => String.fromCharCode(code));
};
export const decimalPrice = (price, currencySettings) => {
  const minorUnits = (currencySettings == null ? void 0 : currencySettings.fractionSize) ?? (currencySettings == null ? void 0 : currencySettings.minorUnits) ?? 2;
  const decimalFactor = 1 / Math.pow(10, minorUnits);
  return Number(price * decimalFactor);
};
export const formatPrice = (price, currencySettings) => {
  if (!currencySettings) {
    return '';
  }
  const currencyFormattedSymbol = getCurrencySymbol(currencySettings);
  const isNegative = price < 0;
  return `${isNegative ? '-' : ''}${currencyFormattedSymbol}${decimalPrice(Math.abs(price), currencySettings).toFixed(2)}`;
};
//# sourceMappingURL=priceFormatting.js.map